import React from 'react'
import PropTypes from 'prop-types'
import { withTranslation } from 'react-i18next'
import api from '../../api/api'
import { getPaginationInfo, processError } from '../../lib/lib'
import { Row, Col, Table } from 'reactstrap'
import TableItem from './components/TableItem'
import Pagination from 'react-js-pagination'
import { CaretRight, CaretLeft } from 'phosphor-react'
import Cookies from 'universal-cookie'
const cookies = new Cookies()

class StudyHistory extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            logs: [],
            page: this.props.match.params.page || 1,
            limit: 100,
            totalItems: 0,
            paginationRange: 5,
            order: 'DESC',
            sort: 'createdAt',
        }
        this.changePage = this.changePage.bind(this)
        this.sortBy = this.sortBy.bind(this)
    }

    async changePage(page) {
        await this.props.history.push(`/logs/${page}`)
        const token = cookies.get('accessToken')
        const lang = this.props.i18n.language
        const sort = this.state.sort
        const order = this.state.order
        const { start, end } = getPaginationInfo({ page: this.props.match.params.page || 1, limit: this.state.limit })
        const { rows } = await this.getUserStudyHistory({ token, lang, start, end, sort, order })
        this.setState({ logs: rows, page })
    }

    getUserStudyHistory(data) {
        return new Promise((resolve, reject) => {
            // api.getUserLogs(data)
            api.getUserStudyHistory(data)
                .then((res) => resolve(res))
                .catch((e) => {
                    processError(e, this.props.history)
                    reject(e)
                })
        })
    }

    async componentWillMount() {
        const token = cookies.get('accessToken')
        const lang = this.props.i18n.language
        const sort = this.state.sort
        const order = this.state.order
        const { start, end } = getPaginationInfo({ page: this.props.match.params.page || 1, limit: this.state.limit })
        const { rows, count } = await this.getUserStudyHistory({ token, lang, start, end, sort, order })
        this.setState({ logs: rows, totalItems: count })
    }

    async sortBy(sort) {
        const token = cookies.get('accessToken')
        const lang = this.props.i18n.language
        const order = this.state.order
        const { start, end } = getPaginationInfo({ page: this.props.match.params.page || 1, limit: this.state.limit })
        const { rows } = await this.getUserStudyHistory({ token, lang, start, end, sort, order })
        this.setState({ logs: rows, sort, order: this.state.order === 'DESC' ? 'ASC' : 'DESC' })
    }

    render() {
        const { t } = this.props
        return (
            <div>
                <div className="content news-bg position-relative">
                    <Row className="w-100 m-0">
                        <Col xs={12} md={12} className="p-0">
                            <div className="page-title">
                                <div className="float-left">
                                    <h1 className="title news-dashboard text-lowercase xl-font-size">{t('profile-activity-history')}</h1>
                                </div>
                            </div>

                            <div className="col-xl-12">
                                <section>
                                    <div className="content-body news-bg">
                                        {' '}
                                        <Row className="px-30">
                                            <Table>
                                                <thead>
                                                    <tr className="border-b-0 logs-table-header md-font-size">
                                                        <th className="sortable" onClick={() => this.sortBy('type')}>{t('profile-logs-status')}</th>
                                                        <th className="sortable" onClick={() => this.sortBy('createdAt')}>{t('profile-logs-date')}</th>
                                                        <th>{t('profile-logs-time')}</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {this.state.logs.map((log, index) => (
                                                        <TableItem key={index}
                                                            id={`${log}-${index}`}
                                                            text={log.data}
                                                            time={log.createdAt}
                                                            type={log.type}
                                                        />
                                                    ))}
                                                </tbody>
                                            </Table>
                                        </Row>
                                        {
                                            this.state.totalItems > this.state.limit ?
                                                <Row className="pagination-row">
                                                    <Pagination
                                                        activePage={Number(this.props.match.params.page) || 1}
                                                        itemsCountPerPage={this.state.limit}
                                                        totalItemsCount={this.state.totalItems}
                                                        pageRangeDisplayed={this.state.paginationRange}
                                                        onChange={this.changePage}
                                                        itemClass={'page-item'}
                                                        disabledClass={'disabled'}
                                                        activeClass={'active'}
                                                        activeLinkClass={'active'}
                                                        linkClass={'page-link'}
                                                        itemClassFirst={'d-none'}
                                                        itemClassLast={'d-none'}
                                                        linkClassPrev={'arrow'}
                                                        linkClassNext={'arrow'}
                                                        nextPageText={<CaretRight size={16} />}
                                                        prevPageText={<CaretLeft size={16} />}
                                                    />
                                                </Row> : ''
                                        }
                                    </div>
                                </section>
                            </div>
                        </Col>
                    </Row>
                </div>
            </div >
        )
    }
}

StudyHistory.propTypes = {
    i18n: PropTypes.object,
    t: PropTypes.func,
    match: PropTypes.object,
    history: PropTypes.object,
}

export default withTranslation()(StudyHistory)



// WEBPACK FOOTER //
// ./src/views/StudyHistory/StudyHistory.jsx